module.exports = __webpack_public_path__ + "static/img/1177_phase_function_Paper_PointsHejduk_Prediction.626c10f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1177_phase_function_Paper_PointsHejduk_Prediction.png
// module id = h5E1
// module chunks = 0